import api from './api'

export const schoolGradesApi = {
  /**
   * Get list of school grades with optional filters
   * @param {Object} params - Query parameters
   * @param {boolean} params.is_active - Filter by active status
   * @returns {Promise} API response
   */
  async getSchoolGrades(params = {}) {
    const queryParams = new URLSearchParams()

    if (params.is_active !== null && params.is_active !== undefined) {
      queryParams.append('is_active', params.is_active)
    }

    const queryString = queryParams.toString()
    const url = queryString ? `/school-grades?${queryString}` : '/school-grades'

    const response = await api.get(url)
    return response
  },

  /**
   * Get single school grade details
   * @param {number} id - School grade ID
   * @returns {Promise} API response
   */
  async getSchoolGrade(id) {
    const response = await api.get(`/school-grades/${id}`)
    return response
  },

  /**
   * Create new school grade
   * @param {Object} gradeData - School grade data
   * @param {number} gradeData.grade - Grade number (3-11)
   * @param {boolean} gradeData.is_active - Grade active status
   * @returns {Promise} API response
   */
  async createSchoolGrade(gradeData) {
    const response = await api.post('/school-grades', gradeData)
    return response
  },

  /**
   * Update existing school grade
   * @param {number} id - School grade ID
   * @param {Object} gradeData - Updated grade data
   * @returns {Promise} API response
   */
  async updateSchoolGrade(id, gradeData) {
    const response = await api.put(`/school-grades/${id}`, gradeData)
    return response
  },

  /**
   * Delete school grade
   * @param {number} id - School grade ID
   * @returns {Promise} API response
   */
  async deleteSchoolGrade(id) {
    const response = await api.delete(`/school-grades/${id}`)
    return response
  }
}